import React, { useState } from 'react'
import './quest-map-image.styles.scss';
import placeholder_icon from '@/assets/placeholder-map.png';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import { resizeImage } from '@/utils/resizeImage';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';
import ContentManager from '@/components/SHARED/content-manager/content-manager.component';
import { getOptimizedImageNoCrop } from '@/utils/getOptimizedBlob';
import { UseCloudFunction } from '@/utils/firebase.utils';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import { RandomString } from '@/utils/randomString';
import { useLocation } from 'react-router-dom';

const QuestMapImageNoCrop = ({
  type,
  saveData,
  formData,
  gameData
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const membership = useSelector(state => state.userData.membership);
  const [alertMessage, setAlertMessage] = useState(null);
  const [contentManagerElement, setContentManagerElement] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation(); 

  function clickUpload() {
    document.getElementById('mapImageUpload').click();
  }

  function handleUpload(file) {
    if (location.pathname.includes('/preview/manager/')) {
      setAlertMessage('Sorry! Data cannot be saved while in preview mode.');
      return;
    }
    function cancelUpload() {
      document.getElementById('mapImageUpload').value = null;
      saveData('icon', null);
      // setFileName(null);
      return;
    }
    const ext = file.name.match(/\.([^\.]+)$/)[1].toLowerCase();
    console.log(ext);
    const allowed = ['jpg', 'bmp', 'png', 'tif', 'webp']
    if (!allowed.includes(ext)) {
      setAlertMessage('That file type is not allowed to be uploaded. Try a different file.');
      cancelUpload();
      return;
    }
    console.log(file.size);
    if (file.size > 5 * 1024 * 1024) {
      setAlertMessage('That file is too large to be uploaded. You cannot upload files larger than 5MB.');
      cancelUpload();
      return;
    }
    setFile(file);
  }

  async function setFile(file) {
    setLoading(true);
    // document.getElementById('selected-image').classList.add('hide')
    console.log(file.type)
    if (file.type.match(/image.*/)) {
      const fileType = file.type;
      const fileName = file.name;
      console.log('An image has been loaded');
      console.log(fileType)
      // Load the image
      if (fileType.indexOf('gif') == -1) {
        const optimizedFile = await getOptimizedImageNoCrop(file, 20, 600, true);

        const reader = new FileReader();
        const imageUrl = await new Promise((resolve, reject) => {
          reader.onloadend = async () => {
            const base64String = reader.result.split(',')[1];
            const uploadRes = await UseCloudFunction(
              'uploadFileToStorage',
              {
                'fileDataBase64': base64String,
                'fileName': fileName,
                'fileType': fileType,
                'folder': userProfile.appId,
                'userProfile': userProfile.appId
              }
            )
            console.log(uploadRes);
            setLoading(false);
            if (uploadRes.error) {
              setAlertMessage(`Error uploading file: ${uploadRes.error}`);
              reject(uploadRes.error);
              return;
            }
            resolve(uploadRes.url);
          }
          reader.readAsDataURL(optimizedFile);
        });
        saveData('mapImageUrl', imageUrl);
        console.log(imageUrl);
        saveMapImageToMyContent(imageUrl, fileName);
        return;
      }
    }
    setAlertMessage('Please upload an image file.')
    return;
  }

  async function saveMapImageToMyContent(imageUrl, fileName) {
    const now = new Date().getTime();
    try {
      await UseCloudFunction(
        'saveToMyContent',
        {
          'gameId': gameData.gameId,
          'appId': userProfile.appId,
          'source': 'Quest Maps',
          'category': 'Images',
          'cropped': false,
          'contentData': {
            'name': fileName,
            'url': imageUrl,
            'type': 'image',
            'id': `${now}_${RandomString(10)}_image`
          },
        }
      )
    } catch (error) {
      console.log('Error saving to My Content: ', error);
      trackException('Quest Icon Save to My Content Error: ' + error.message);
    }
    trackEvent(
      'image_saved_to_my_content',
      'Game Manager',
      `Quest icon ${fileName} was uploaded for user ${userProfile.appId}.`,
      null,
      membership
    )
    return;
  }

  function chooseHostedIcon(url) {
    document.getElementById('selected-image').classList.remove('hide')
    saveData('mapImageUrl', { 'url': url })
  }

  function chooseElement(elementData) {
    console.log(elementData);
    saveData('mapImageUrl', elementData.url);
    setContentManagerElement(null)
  }

  return (
    <div className={`quest-icon ${screenSize}`}>
      <div><b>Choose a Map</b></div>
      <div className="g-space-2"></div>
      <div className="icon-upload-content">
        <div className="image-buttons">
          <div style={{ cursor: 'pointer' }}>
            <input
              type="file"
              id="mapImageUpload"
              accept="image/*"
              onChange={(e) => handleUpload(e.target.files[0])} />
            <button
              className={`g-button ${screenSize === 'mobile' ? 'small-btn' : ''}`}
              type="button"
              tabIndex="-1"
              onClick={() => clickUpload()}>
              Upload a Map
            </button>
          </div>
          <button
            type='button'
            className={`g-button ${screenSize === 'mobile' ? 'small-btn' : ''}`}
            onClick={() => setContentManagerElement('itemIcon')}>
            Choose a Map
          </button>

        </div>

        <div className="image-div">
          <div id="uploadDiv">
            <div id="selected-image">
              {
                (formData.icon && formData.icon.url)
                  ?
                  <ImageContainer
                    className="profile-image"
                    src={formData.icon.url}
                    alt='profile image'
                  />
                  :
                  (formData.icon && !formData.icon.upload)
                    ?
                    <ImageContainer
                      className="profile-image"
                      src={formData.icon}
                      alt='profile image'
                    />
                    :
                    <img
                      className="profile-image"
                      referrerPolicy="no-referrer"
                      src={placeholder_icon} />
              }
            </div>
            <div id="uploaded-image">

            </div>
            <a
              className="rotateButton"
              id="rotateButton">
              <i className="large redo icon"></i>
            </a>
          </div>
        </div>
      </div>
      <div className='meta'>
        For best results, use an image that is at least 600 pixels wide. The image will be resized to 600 pixels when you upload it.
      </div>
      <Modal
        show={contentManagerElement}
        cancel={() => setContentManagerElement(false)}
        closeButton={true}
        text="Content Manager"
        cls="wide" >
        <ContentManager
          element={contentManagerElement}
          chooseElement={chooseElement} />
      </Modal>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <FullPageLoader show={loading} />
    </div>
  )
}

export default QuestMapImageNoCrop